import track from './track';
import getProductData, { prepareProductsData } from './get-product-data';

/**
 * @param {{products: IProduct[]}} data
 * @return {any}
 */
export default function checkout(data) {
    // Bug in IE gives you an empty array for Object.values
    let products = prepareProductsData(data.products);

    return track({
        event: 'checkout',
        ecommerce: {
            currencyCode: 'CHF',
            reqDelivery: data.deliveryTime,
            estCartValue: data.value,
            checkout: {
                actionField: {
                    step: data.step,
                    option: 'stripe',
                },
                products: products.map(getProductData),
            },
        },
    });
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/tracking/checkout.js